var path = 'app/scripts/modules/google/src/serverGroup/configure/wizard/securityGroups/securityGroups.html';
var html = "<div class=\"row\">\n  <gce-server-group-security-groups-removed command=\"command\"></gce-server-group-security-groups-removed>\n  <gce-server-group-security-group-selector command=\"command\"></gce-server-group-security-group-selector>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/serverGroup/configure/wizard/securityGroups/securityGroups.html
// module id = 1358
// module chunks = 0